import { MigrationManifest } from "redux-persist";
import { defaultCar } from "features/cars/redux/creating-cars.slice";

export const migrations: MigrationManifest = {
	1: (state: any) => ({
		...state,
		creatingCars: {
			list: [defaultCar],
		},
	}),
};
